import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { Bank } from '../../models/bank.model';

@Injectable({ providedIn: 'root' })
export class BankService {
  constructor(private dataService: DataService) { }

  public delete(cod: number) {
    return this.dataService.delete<Result>('bank/' + cod.toString());
  }

  public get() {
    return this.dataService.get<Result<any>>('banks');
  }

  public getRequestBanks(requestId: number) {
    return this.dataService.get<Result<any>>('banks/request/' + requestId);
  }

  public getPartnerBanks() {
    return this.dataService.get<Result<any>>('partnerbanks');
  }

  public insert(bank: Bank) {
    bank.member = bank.member ? 'S' : 'N';
    return this.dataService.post<Result<Bank>>('bank', bank);
  }

  public update(bank: Bank) {
    bank.member = bank.member ? 'S' : 'N';
    return this.dataService.put<Result<Bank>>('bank', bank);
  }

  public getByKey(id: number) {
    return this.dataService.get<Result<Bank>>('bank/' + id);
  }


}

